import PickerColor from './PickerColor.vue'

export default PickerColor
